import './index.css';
import { TextProfileIcon } from '../TextProfileIcon';
import { callIdIcon, dateIcon, pinIcon, phoneIcon, profileIcon, recordIcon } from '../../assets';
import { observer } from 'mobx-react';
import { formatDate } from '../../helpers/functions';
import AuthStore from '../../stores/AuthStore';
import strings from '../../localization';
import CallStore from '../../stores/CallStore';
import { StateList } from '../../helpers/statics';

const CallSessionInformationWithRecords = () => {

  const user = AuthStore.user;
  const call = CallStore.call;

  const RecordComponent = ({ record, index }) => {
    return (
      <a href={record.presignedUrl} className="call-session-information-with-records-record-item" key={record._id} target="_blank">
        <img src={recordIcon} alt="record" />
        <span>{strings.watchSessionRecording + ' 0' + (index + 1)}</span>
      </a>
    )
  }



  const name = user?.name;
  const surname = user?.surname;
  const fullName = `${name} ${surname}`;


  const callId = call?._id;
  const date = formatDate(call?.createdAt);
  const pin = call?.pin;
  const slug = call?.slug;
  const customer = call?.customer;
  const technician = call?.technician?.name + ' ' + call?.technician?.surname;

  const records = CallStore.call?.recordings || [];
  const statusLabel = StateList.find((item) => item.key === call?.state)?.title ?? call?.state ?? '';

  return (
    <div className="call-session-information-with-records-container">

      <div className="call-session-information-with-records-header">
        <div className="call-session-information-with-records-profile">
          <TextProfileIcon text={fullName} />
          <div className="call-session-information-with-records-profile-name">
            <span>{fullName}</span>
            <span>Slug: {slug}</span>
          </div>
        </div>

        <div className="call-session-information-with-records-records">
          <div className="call-session-information-with-records-records-inner">
            {records.map((record, index) => (
              <RecordComponent key={record._id} record={record} index={index} />
            ))}
          </div>
        </div>

      </div>

      <div className="call-session-information-with-records-items">
        <div className="call-session-information-with-records-item">
          <img src={callIdIcon} alt="call-id" />
          <span>{strings.callId}</span>
          <span>{callId}</span>
        </div>
        <div className="call-session-information-with-records-item">
          <img src={dateIcon} alt="date" />
          <span>{strings.date}</span>
          <span>{date}</span>
        </div>
        <div className="call-session-information-with-records-item">
          <img src={dateIcon} alt="date" />
          <span>{strings.technician}</span>
          <span>{technician}</span>
        </div>
        <div className="call-session-information-with-records-item">
          <img src={pinIcon} alt="pin" />
          <span>{strings.pin}</span>
          <span>{pin}</span>
        </div>
        <div className="call-session-information-with-records-item">
          <img src={phoneIcon} alt="phone" />
          <span>{strings.phone}</span>
          <span>{customer}</span>
        </div>
        <div className="call-session-information-with-records-item">
          <img src={profileIcon} alt="status" />
          <span>{strings.status}</span>
          <span>{statusLabel}</span>
        </div>
      </div>

    </div>
  );
};

export default observer(CallSessionInformationWithRecords);


// LOCALIZATION WAITING